export const PRODUCT_TYPE = {
  ACCIDENTAL_DEATH: "accidentalDeath",
  FINAL_EXPENSE: "fex",
  LTC: "ltc",
  NON_MED: "non_med",
  ACCUMULATION_IUL: "aiul",
  PROTECTION_IUL: "piul",
  PROTECTION_VUL: "pvul",
  UNIVERSAL_LIFE: "ul",
  ROP_TERM: "ropTerm",
  TERM: "term",
  WHOLE_LIFE: "wholeLife",
  LINKED_BENEFIT: "linkedBenefit",
  INCOME_RIDER: "incomeRider",
};

export const UL_TYPE = {
  [PRODUCT_TYPE.ACCUMULATION_IUL]: PRODUCT_TYPE.ACCUMULATION_IUL,
  [PRODUCT_TYPE.PROTECTION_IUL]: PRODUCT_TYPE.PROTECTION_IUL,
  [PRODUCT_TYPE.PROTECTION_VUL]: PRODUCT_TYPE.PROTECTION_VUL,
  [PRODUCT_TYPE.UNIVERSAL_LIFE]: PRODUCT_TYPE.UNIVERSAL_LIFE,
};

export const UL_TYPES = Object.values(UL_TYPE);
export type ProductType = (typeof PRODUCT_TYPE)[keyof typeof PRODUCT_TYPE];
export type UlType = (typeof UL_TYPE)[keyof typeof UL_TYPE];

export function extractProducts(str: string) {
  if (!str?.indexOf) return null;
  const rawCategory = str.split(".");
  const [base] = rawCategory;
  const categories = [];
  if (base === "whole_life") {
    if (rawCategory.includes("none")) {
      categories.push(PRODUCT_TYPE.WHOLE_LIFE);
    }
    if (rawCategory.includes("final_expense")) {
      categories.push(PRODUCT_TYPE.FINAL_EXPENSE);
    }
  }

  if (base === "universal_life") {
    if (rawCategory.includes("variable")) {
      categories.push(PRODUCT_TYPE.PROTECTION_VUL);
    }
    if (rawCategory.includes("accumulation")) {
      categories.push(PRODUCT_TYPE.ACCUMULATION_IUL);
    }
    if (rawCategory.includes("protection")) {
      categories.push(PRODUCT_TYPE.PROTECTION_IUL);
    }
    if (rawCategory.includes("none")) {
      categories.push(PRODUCT_TYPE.UNIVERSAL_LIFE);
    }
    if (rawCategory.includes("linked_benefit")) {
      categories.push(PRODUCT_TYPE.LINKED_BENEFIT);
    }
  }

  if (base === "term") {
    if (rawCategory.includes("none")) {
      categories.push(PRODUCT_TYPE.TERM);
    }
    if (rawCategory.includes("return_of_premium")) {
      categories.push(PRODUCT_TYPE.ROP_TERM);
    }
    if (rawCategory.includes("non_med")) {
      categories.push(PRODUCT_TYPE.NON_MED);
    }
    if (rawCategory.includes("ul_term")) {
      categories.push(PRODUCT_TYPE.UNIVERSAL_LIFE);
    }
  }

  if (base === "accidental_death") {
    if (rawCategory.includes("accidental_death")) {
      categories.push(PRODUCT_TYPE.ACCIDENTAL_DEATH);
    }
  }

  if (base === "annuity") {
    if (rawCategory.includes("income_rider")) {
      categories.push(PRODUCT_TYPE.INCOME_RIDER);
    }
  }

  if (base === "ltc") {
    categories.push(PRODUCT_TYPE.LTC);
  }

  return categories;
}
